<template>
    <GChart
        type="LineChart"
        :settings="{packages: ['corechart'], language: 'pt-br'}"
        :data="chartDataFinal"
        :options="chartOptions"
    />
</template>

<script>
export default {
    props: ['chartData'],
    data() {
        return {
            chartOptions: {
                fontName: 'Inter',
                height: 400,
                curveType: 'function',
                legend: {
                    position: 'top',
                    alignment:'center',
                    maxLines: 3
                },
                vAxis: {
                    ticks: [0,250,500,750,1000]
                }
                //chartArea: {width: '100%', height: '90%'},
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>

</style>
